import { http } from './config';

const ANUNCIO_PATH = 'anuncio';

export default {
  listar: ({ page }) => http.get(`${ANUNCIO_PATH}?page=${page}`),

  listarTodos: () => http.get(`${ANUNCIO_PATH}?all=true`),

  salvar: anuncio => http.post(ANUNCIO_PATH, anuncio),

  atualizar: produto => http.post(`${ANUNCIO_PATH}/${produto._id}`, produto),

  deletar: produto => http.delete(`${ANUNCIO_PATH}/${produto._id}`)
};
